<template>
  <div>
    <transition name="fade">
      <div class="loader inset-0 top-0 bottom-0 right-0"
        :style="{ position: position }"
        style="position: absolute; top: 0; left: 0; bottom: 0; z-index: 10;
          min-height: 5rem; background: rgba(0,0,0,.35">
        <svg xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="loading-icon"
          style="margin: auto;background: none;display: block;shape-rendering: auto;
            position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"
          width="50px"
          height="50px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
        <circle cx="50" cy="50" fill="none" stroke="#ffffff"
          stroke-width="10" r="35"
          stroke-dasharray="164.93361431346415 56.97787143782138"
          transform="rotate(140.168 50 50)">
          <animateTransform attributeName="transform" type="rotate"
            repeatCount="indefinite" dur="2s" values="0 50 50;360 50 50"
            keyTimes="0;1">
          </animateTransform>
        </circle>
        </svg>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    position: {
      type: String,
      default: 'absolute',
    },
  },
};
</script>
